import React, {Component} from 'react';
import {connect} from 'react-redux';
import {isNumber, sumBy} from 'lodash';
import {Card, Table, Loader, Header} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';

const valueIfNull = '0';

class ReportQuotes extends Component {
  validateZero = (number) => {
    if (!number) {
      return 0;
    } else if (isNaN(number)) {
      return 0;
    } else if (!isFinite(number)) {
      return 0;
    } else if (!isNumber(+number)) {
      return 0;
    }
    return +number;
  }

  renderLoaderOrSales = () => {
    const {loadingModels, loadingSales} = this.props;

    if (loadingModels || loadingSales) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation = () => {
    const {showDefaultValues, models, sales} = this.props;
    const data = showDefaultValues ? models : sales;
  
    return data.map((record, index) => {
      const totalCloseFloor = record.salesFloor ?
        getNumericValue((record.salesFloor / record.quotesFloor) * 100, 2) : 0;
      const totalCloseDigital = record.salesDigital ?
        getNumericValue((record.salesDigital / record.quotesDigital) * 100, 2) : 0;
        /* eslint-disable max-len */
      const totalClose =
        getNumericValue(((record.salesFloor + record.salesDigital) / (record.quotesFloor + record.quotesDigital)) * 100, 2);

      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell collapsing className='lightgray-bg'>
            {showDefaultValues ? record.name : record.vehicleModelName}
          </Table.Cell>
          <Table.Cell>{record.salesFloor || valueIfNull}</Table.Cell>
          <Table.Cell>{record.quotesFloor || valueIfNull}</Table.Cell>
          <Table.Cell>
            {this.validateZero(totalCloseFloor)} %
          </Table.Cell>
          <Table.Cell>{record.salesDigital || valueIfNull}</Table.Cell>
          <Table.Cell>{record.quotesDigital || valueIfNull}</Table.Cell>
          <Table.Cell>
            {this.validateZero(totalCloseDigital)} %
          </Table.Cell>
          <Table.Cell>
            {(+record.salesFloor + +record.salesDigital) || valueIfNull}
          </Table.Cell>
          <Table.Cell>
            {(+record.quotesFloor + +record.quotesDigital) || valueIfNull}
          </Table.Cell>
          <Table.Cell>{this.validateZero(totalClose) || valueIfNull} %</Table.Cell>
        </Table.Row>
      );
    });
  }

  // eslint-disable-next-line max-statements
  renderTotals = () => {
    const {loadingModels, loadingSales, showDefaultValues, models, sales} = this.props;
    const data = showDefaultValues ? models : sales;

    if (loadingModels || loadingSales) {
      return null;
    }
    
    const totalSalesFloor = sumBy(data, 'salesFloor');
    const totalSalesDigital = sumBy(data, 'salesDigital');
    const totalQuotesFloor = sumBy(data, 'quotesFloor');
    const totalQuotesDigital = sumBy(data, 'quotesDigital');

    const floorClosingRates = +((totalSalesFloor / totalQuotesFloor) * 100).toFixed(2);
    const digitalClosingRates = +((totalSalesDigital / totalQuotesDigital) * 100).toFixed(2);
    const totalClosingRates =
    +(((totalSalesFloor + totalSalesDigital) / (totalQuotesFloor + totalQuotesDigital)) * 100).toFixed(2);

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell className='lightgray-bg'>Total</Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalSalesFloor || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalQuotesFloor || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {this.validateZero(floorClosingRates)} %
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalSalesDigital || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalQuotesDigital || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {this.validateZero(digitalClosingRates)} %
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {(totalSalesFloor + totalSalesDigital) || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {(totalQuotesFloor + totalQuotesDigital) || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {this.validateZero(totalClosingRates)} %
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card raised fluid>
        <Header as='h2'
          className='header-report'
          textAlign="left" >Reporte Cotizaciones</Header>
        <Table className='gray-table'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='lightgray-bg'>Modelos</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Ventas Piso</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Cotizaciones Piso</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Tasa Cierre Piso</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Ventas Digitales</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Cotizaciones Digitales</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Tasa Cierre Digital</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Ventas Totales</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Cotizaciones Totales</Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>Tasa Cierre Total</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderLoaderOrSales()}
          </Table.Body>

          {this.renderTotals()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingModels': state.vehiclesModels.loading,
    'models': state.vehiclesModels.vehicles,
    'loadingSales': state.dailyVehiclesSalesAndStock.loadingSales,
    'sales': state.dailyVehiclesSalesAndStock.salesList,
  };
};

export default connect(mapStateToProps, {})(ReportQuotes);
